type ToCurrencyPayload = {
  value: number;
  locale?: string;
  currency?: string;
  precision?: number;
};

const formatNum = (num: number) =>
  Intl.NumberFormat('en-GB', {
    maximumFractionDigits: 2,
  }).format(num);

export const toCurrency = (payload: ToCurrencyPayload): string => {
  return new Intl.NumberFormat(payload.locale ? payload.locale : 'en-GB', {
    style: 'currency',
    currency: payload.currency ? payload.currency : 'GBP',
    minimumFractionDigits: payload.precision ? payload.precision : 2,
  }).format(payload.value);
};

export const toArea = (a: any) => `${formatNum(a.width && a.len ? a.len * a.width : a)}m²`;

export const toVolume = (a: any) => `${formatNum(a.width && a.len && a.height ? a.len * a.width * a.height : a)}m³`;
